import { AfterViewInit, Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { tap, timeInterval } from 'rxjs/operators';
import { Router } from '@angular/router';
import { merge } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { Toolbar, ToolbarEvent } from 'src/app/shared/components/toolbar/toolbar';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { RichiesteDgpeDataSource } from 'src/app/services/richieste-dgpe.datasource';
import { RichiesteDgpeService } from 'src/app/services/richieste-dgpe.service';
import { DialogService } from 'src/app/services/dialog.service';

@Component({
  selector: 'app-elenco-richieste',
  templateUrl: './elenco-richieste.component.html',
  styleUrls: ['./elenco-richieste.component.css']
})
export class ElencoRichiesteComponent implements OnInit, AfterViewInit {


  arrowFlag: boolean = false;
  risultatiPerPagina: number = 10;
  dataSource: RichiesteDgpeDataSource;
  public form: FormGroup;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('orderBy') orderBy: MatSelect;


  /**
   *
   *
   * @type {EventEmitter<ToolbarEvent>}
   * @memberof DataTableComponent
   */
  @Output()
  public onToolbarEvent: EventEmitter<ToolbarEvent> = new EventEmitter();

  /**
 *
 * Filtri di ricerca impostati dall'utente
 * @type {ModelEventiCalamitosi.EventiSearchableDto}
 */
  public searchFilters: ModelEventiCalamitosi.RichiestaDgpeFilterDTO = {
    ocdpc:null,
    informazioniOcdpc:null,
    commissario:null,
    dataInizioDa:null,
    dataInizioA:null,
    dataFineDa:null,
    dataFineA:null
  };
  isLoading: boolean = false;
  openToggle: number = 0;

  private buildForm(): void {
    let group = {
      ocdpc: new FormControl(null, null),
      informazioniOcdpc: new FormControl(null, null),
      commissario: new FormControl(null, null),
      dataInizioDa: new FormControl(null, null),
      dataInizioA: new FormControl(null, null),
      dataFineDa: new FormControl(null, null),
      dataFineA: new FormControl(null, null),
    }
    this.form = new FormGroup(group);
  }

  constructor(
    private router: Router,
    private alertsCenterService: AlertsCenterService,
    private authenticationService: AuthenticationService,
    private ocdpcDialogSvc: DialogService,
    private richiesteDgpeService : RichiesteDgpeService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.dataSource = new RichiesteDgpeDataSource(this.richiesteDgpeService);
    this.dataSource.errors$.subscribe(res => {
      if(res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })
    //
  }

  //rimane in ascolto: se il click non è fatto sull'icona chiude il menù
  @HostListener('document:click', ['$event'])
    documentClick(event) {
        if(event.srcElement.innerText !== 'more_horiz') this.openToggle = 0;
    }


  //questa variabile, associata a *matHeaderRowDef, definisce l'ordine di visualizzazione delle colonne
  displayedColumns: string[] = ['ocdpc', 'informazioniOcdpc', 'territorio', 'commissario', 'dataInizio', 'dataFine', 'actions'];
  //dataSourceOld = new MatTableDataSource(this.datiListaEventi);

  ngAfterViewInit() {
    setTimeout(() => {
      // this.dataSource.loadEventi('', this.eventiSearchableDto, 'idEvento,ASC', 0, this.risultatiPerPagina);

      this.dataSource.loadOcdpc('',this.searchFilters,'dataInizio,DESC', this.paginator.pageIndex, this.paginator.pageSize);

      this.form.valueChanges.subscribe(() => this.paginator.pageIndex = 0);
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          tap(() => {
            this.ricercaListaRichieste();
          }))
        .subscribe();

      this.dataSource.counter$
        .pipe(
          tap((count) => {
            this.paginator.length = count;
          })
        )
        .subscribe();
    });
  }

  public ricercaListaRichieste(resetPage?: boolean): void {

     this.searchFilters = {
       ocdpc: this.form.controls['ocdpc'].value !== "" ? this.form.controls['ocdpc'].value : null,
       informazioniOcdpc: this.form.controls['informazioniOcdpc'].value !== "" ? this.form.controls['informazioniOcdpc'].value : null,
       commissario: this.form.controls['commissario'].value !== "" ? this.form.controls['commissario'].value : null,
       dataInizioDa: this.form.controls['dataInizioDa'].value !== "" ? this.form.controls['dataInizioDa'].value : null,
       dataInizioA: this.form.controls['dataInizioA'].value !== "" ? this.form.controls['dataInizioA'].value : null,
       dataFineDa: this.form.controls['dataFineDa'].value !== "" ? this.form.controls['dataFineDa'].value : null,
       dataFineA: this.form.controls['dataFineA'].value !== "" ? this.form.controls['dataFineA'].value : null,
     }


     if(this.checkData(this.searchFilters)) {
       this.dataSource.loadOcdpc('', this.searchFilters, this.sort.active + "," + this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize);
     }

  }
  onNavigate(path) {
    this.router.navigate([path])
  }

  /**
 *
 *
 * @private
 * @memberof SearchComponent
 */
  public generateToolBar(element: ModelEventiCalamitosi.RichiestaDgpeDTO): Toolbar {
    if(element.numEventi > 0) {
      return {
        toolbarCss: 'toolbar-vertical',
        actions: [
          {
            btnTitle: 'Dettaglio',
            btnIconClass: 'article',
            btnActionEvent: 'detail',
            btnCssClass: 'btn btn-secondary'
          },
          {
            btnTitle: 'Modifica',
            btnIconClass: 'create',
            btnActionEvent: 'edit',
            btnCssClass: 'btn btn-secondary'
          },
        ]
      }
    } else {
      return {
        toolbarCss: 'toolbar-vertical',
        actions: [
          {
            btnTitle: 'Dettaglio',
            btnIconClass: 'article',
            btnActionEvent: 'detail',
            btnCssClass: 'btn btn-secondary'
          },
          {
            btnTitle: 'Modifica',
            btnIconClass: 'create',
            btnActionEvent: 'edit',
            btnCssClass: 'btn btn-secondary'
          },
          {
            btnTitle: 'Elimina',
            btnIconClass: 'delete',
            btnActionEvent: 'remove',
            btnCssClass: 'btn btn-primary'
          }
        ]
      }
    }

  }

  public handleToolbarEvent(event: ToolbarEvent): void {
    if (event.event === 'edit') {
      this.onNavigate('elenco-richieste/modifica-richiesta/' + event.data.idRichiesta)
    }
    else if (event.event === 'detail') {
      this.onNavigate('elenco-richieste/dettaglio-richiesta/' + event.data.idRichiesta)
    }
    else if (event.event === 'remove') {      
      this.openDeleteConfirmDialog(event.data.idRichiesta);
    }
  }

  /**
   * deleteRichiesta
   */
  public deleteRichiesta(idRichiesta: number) {
    this.richiesteDgpeService.delete(idRichiesta).subscribe(results => {
      this.alertsCenterService.showAlert({
        message: `Cancellazione effettuata con successo`,
        type: 'success',
        autoClosable: false
      });
      this.ricercaListaRichieste();
    }, err => {
      this.alertsCenterService.showAlert({
        message: err.error.esitoServizio.descrizioneEsito,
        type: 'danger',
        autoClosable: false,
        closeInMillis: 6000
      });
    })
  }

  openDeleteConfirmDialog(idRichiesta: number) {
    let title = 'Cancellazione OCDPC';
    let message = 'Vuoi davvero eliminare questa richiesta?'
    this.ocdpcDialogSvc.openDialog(title, message).subscribe(
      result => {
        let confirmed = `${result}`;
        if (confirmed == "true") {
          this.deleteRichiesta(idRichiesta);
        }
      }
    );
  }

  onReset() {
    this.searchFilters = {
      ocdpc:null,
      informazioniOcdpc:null,
      commissario:null,
      dataInizioDa:null,
      dataInizioA:null,
      dataFineDa:null,
      dataFineA:null
    };
    this.form.reset();
    this.dataSource.loadOcdpc('',this.searchFilters,'dataInizio,DESC', this.paginator.pageIndex, this.paginator.pageSize);
  }


/**
 * Metodo di controllo per le date: se ci sono entrambe le controlla, se c'è una sola, aggiunge max o min all'altra
 * @param searchFilters
 */
 private checkData(searchFilters: ModelEventiCalamitosi.RichiestaDgpeFilterDTO) : boolean {

  if(this.searchFilters.dataInizioA && this.searchFilters.dataInizioDa) {
    if (this.form.controls.dataInizioDa.value > this.form.controls.dataInizioA.value) {
      let message = "Data di inizio maggiore della data di fine"
      this.alertsCenterService.showAlert({
        message: message,
        type: 'danger',
        autoClosable: false
      });
      return false;
    }
  } else if(this.searchFilters.dataInizioA) {
    this.searchFilters.dataInizioDa = "1900-01-01"
  } else if(this.searchFilters.dataInizioDa) {
    this.searchFilters.dataInizioA = "4000-01-01"
  }

  if(this.searchFilters.dataFineA && this.searchFilters.dataFineDa) {
    if (this.form.controls.dataFineDa.value > this.form.controls.dataFineA.value) {
      let message = "Data di inizio maggiore della data di fine"
      this.alertsCenterService.showAlert({
        message: message,
        type: 'danger',
        autoClosable: false
      });
      return false;
    }
  } else if(this.searchFilters.dataFineA) {
    this.searchFilters.dataFineDa = "1900-01-01"
  } else if(this.searchFilters.dataFineDa) {
    this.searchFilters.dataFineA = "4000-01-01"
  }

  return true;
 }

}
